module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAABCAYAAAAGu30GAAAALklEQVR4AWNYsGDxzKGIDx890TOc8PuPXxvoid9t2jYJgUfxKB7Fo3gU07scBgAfLnVM46kPsQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids/selfcare_sidenav+2level+maincontainer.png
// module id = 352
// module chunks = 0